export default __webpack_public_path__ + "static/media/wallet.eca9df74.svg";